import React, { useRef, useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Kard.css";

function Kard({ kurslar, setKurs_id, filterType, kurs_id, setActiveMavzu }) {
  const [kardClass, setkardClass] = useState(kurs_id);
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [hasMoved, setHasMoved] = useState(false);

  // Sync internal state with external course selection
  useEffect(() => {
    setkardClass(kurs_id);
  }, [kurs_id]);

  // Reset scroll position when category changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0;
    }
  }, [filterType]);

  const aktivKardClass = (i) => {
    if (!hasMoved) {
      setkardClass(i);
    }
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    setHasMoved(false);
  };

  const stopDragging = () => {
    setIsDragging(false);
  };

  const onDrag = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
    if (Math.abs(walk) > 5) setHasMoved(true);
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const kardlar = kurslar
    .filter((kurs) => {
      if (filterType === "algoritm") {
        return kurs.turi === 1;
      }
      if (filterType === "web") {
        return kurs.turi === 2 || kurs.turi === 4;
      }
      return kurs.turi === 3;
    })
    .map((kurs) => {
      const isReady =
        (kurs.id >= 7 && kurs.id <= 12) || (kurs.id >= 19 && kurs.id <= 23);
      return (
        <div
          onClick={() => {
            if (!hasMoved) {
              setKurs_id(kurs.id);
              setActiveMavzu(0);
              aktivKardClass(kurs.id);
            }
          }}
          className={
            (kardClass === kurs.id ? "kard-icon kardAktiv" : "kard-icon") +
            (isReady ? " tayyor" : "")
          }
          key={kurs.id}
        >
          <img src={kurs.rasm} alt={kurs.nomi} />
          <span>{kurs.nomi}</span>
          {parseFloat(kurs.narx) === 0 && <div className="kard-free-badge">Bepul</div>}
        </div>
      );
    });

  return (
    <div className="slider-outer-wrapper">
      <div className="slider-container">
        <button className="slider-button left" onClick={() => scroll("left")}>
          <FaChevronLeft />
        </button>
        <div
          className={`kard-quti ${isDragging ? "active" : ""}`}
          ref={scrollRef}
          onMouseDown={startDragging}
          onMouseLeave={stopDragging}
          onMouseUp={stopDragging}
          onMouseMove={onDrag}
        >
          {kardlar}
        </div>
        <button className="slider-button right" onClick={() => scroll("right")}>
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}

export default Kard;
